"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Frontrunner = void 0;
class Frontrunner {
    constructor() {
        this.name = 'Frontrunner';
        this.description = 'Have a net total of at least 6 VP on played cards';
    }
    getScore(player) {
        let score = 0;
        for (const playedCard of player.playedCards) {
            if (playedCard.getVictoryPoints !== undefined) {
                score += playedCard.getVictoryPoints(player);
            }
        }
        player.corporationCards.forEach((corp) => {
            if (corp.getVictoryPoints !== undefined) {
                score += corp.getVictoryPoints(player);
            }
        });
        return score;
    }
    canClaim(player) {
        return this.getScore(player) >= 6;
    }
}
exports.Frontrunner = Frontrunner;
//# sourceMappingURL=Frontrunner.js.map